import { render, staticRenderFns } from "./CertificateDetailsContent.vue?vue&type=template&id=3a7c2b2f&scoped=true"
import script from "./CertificateDetailsContent.vue?vue&type=script&lang=ts"
export * from "./CertificateDetailsContent.vue?vue&type=script&lang=ts"
import style0 from "./CertificateDetailsContent.vue?vue&type=style&index=0&id=3a7c2b2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7c2b2f",
  null
  
)

export default component.exports